export enum UserMessage {
  ACCOUNT_DEACTIVATED = 'this account is deactivated',
  TOO_MANY_ATTEMPTS = 'too many attempts',
  PASSWORD_TOO_SHORT = 'password must be at least 8 letters long',
  INVALID_PASSWORD = 'current Password is invalid',
  PASSWORD_MISMATCH = 'passwords do not match',
  PASSWORD_CHANGE_SUCCESSFUL = 'Password changed successfully.',
  USER_INVITED_TO_ORGANIZATION = 'User Invited. An invite email is sent to this email address.',
  USER_NOT_IN_ORGANIZATION = 'user is not part of any organization',
  TOKEN_EXPIRED = 'token is expired',
  INVALID_TOKEN = 'invite token is invalid',
  USER_DELETED_SUCCESSFULLY = 'User deleted from this organization.',
  USER_ROLE_UPDATED_SUCCESSFULLY = 'User role is updated successfully.',
  USER_INVITE_REVOKED = 'Invitation is revoked for this user.',
  USER_PERSONAL_DETAILS_UPDATED_SUCCESSFULLY = 'User details updated successfully.'
}

export const formattedUserMessage: Record<string, string> = {
  [UserMessage.INVALID_PASSWORD]: 'Current password is incorrect.',
  [UserMessage.PASSWORD_TOO_SHORT]: 'Password must be at least 8 characters.',
  [UserMessage.PASSWORD_MISMATCH]: 'New password and confirm new password are not same.',
  [UserMessage.ACCOUNT_DEACTIVATED]: 'This account is deactivated. Contact support for help.',
  [UserMessage.TOO_MANY_ATTEMPTS]: 'Too many attempts. Try again after 30 minutes.',
  [UserMessage.USER_NOT_IN_ORGANIZATION]: 'You are not associated with any organization so far.',
  [UserMessage.TOKEN_EXPIRED]: 'This invite token is already expired. Please ask them to re-invite.',
  [UserMessage.INVALID_TOKEN]: 'This invite token is invalid.'
}
